import { el } from "@dhx/ts-common/dom";
import { NavigationBarEvents } from "../types";

function onBlur(events, id) {
	events.fire(NavigationBarEvents.inputBlur, [id]);
}

function onFocus(events, id) {
	events.fire(NavigationBarEvents.inputFocus, [id]);
}

function onInput(events, id, e) {
	events.fire(NavigationBarEvents.inputChange, [id, e.target.value]);
}

export function input(item, events, widgetName: string) {
	return el(
		".dhx_form-group.dhx_form-group--no-message-holder.dhx_form-group--label_sr" +
			`.dhx_${widgetName}__input`,
		{
			style: {
				width: item.width ? item.width : "200px",
			},
			role: "presentation",
		},
		[
			item.label && el("label.dhx_label", { for: item.id }, item.label),
			el(
				".dhx_input__wrapper",
				{
					role: "presentation",
				},
				[
					el("input.dhx_input", {
						placeholder: item.placeholder,
						class: item.icon ? "dhx_input--icon-padding" : "",
						value: item.value,
						disabled: item.disabled,
						onblur: [onBlur, events, item.id],
						onfocus: [onFocus, events, item.id],
						oninput: [onInput, events, item.id],
						dhx_id: item.id,
						_hooks: {
							didInsert(node) {
								if (events) {
									events.fire(NavigationBarEvents.inputCreated, [item.id, node.el]);
								}
							},
						},
						_key: item.id,
						"aria-label":
							item.label ||
							item.helpMessage ||
							`type ${item.placeholder ? "text like " + item.placeholder : "text"}`,
					}),
					item.icon
						? el(".dhx_input__icon", {
								class: item.icon,
								"aria-hidden": "true",
						  })
						: null,
				]
			),
		]
	);
}
